import { render } from "./FuncionarioPerfil.vue?vue&type=template&id=1a5ccd02&scoped=true"
import script from "./FuncionarioPerfil.vue?vue&type=script&lang=js"
export * from "./FuncionarioPerfil.vue?vue&type=script&lang=js"

import "./FuncionarioPerfil.vue?vue&type=style&index=0&id=1a5ccd02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5ccd02"]])

export default __exports__